import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';

import { Label } from 'core';
import { Card } from 'core/components/card';
import Button from 'core/components/button/button';
import { FormField } from 'core/components/form';
import { CardAnchorLink } from './anchor-link';
import ProofOfElegibilityDocumentsBlock from './proof-of-elegibility-documents-block';
import AllHouseholdResidentsIncludedBlock from './all-household-residents-included-block';
import NewPIPFormRequiredBlock from './new-pip-form-required-block';
import PreAcceptChangesVerification from './pre-accept-changes-verification';
import rightArrow from 'core/assets/svg/ic-right-arrow.svg';
import openInTab from 'core/assets/svg/open-tab.svg';

import useStyles from './changes-for-approval-section.styles';

const ChangesForApprovalSectionProcessingView = ({
  closePolicyPreviewModal,
  showProofOfEligibilityDocumentsBlock,
  showAllHouseholdResidentsIncludedBlock,
  showNewPIPFormRequiredBlock,
  goToPIPCoverageSection,
  openMemberDocuments,
  previewId
}) => {
  const classes = useStyles();

  return (
    <Card type="primary" className={classes.container}>
      <Label type="darkGreenSmallBold" className={classes.sectionTitle}>
        These changes require your approval.
      </Label>
      <p className={classes.sectionDescription}>
        These changes impact the Personal Injury Protection (PIP) Medical limit, or affects the drivers and household
        residents linked to it. Please verify the policy’s eligibility and that any required documents have been
        provided.
      </p>
      <div className={classes.linkSection}>
        <CardAnchorLink
          label="See PIP coverage options and eligibility requirements"
          onClick={goToPIPCoverageSection}
          icon={rightArrow}
          classes={classes}
          iconClass={classes.arrowIcon}
        />
        <CardAnchorLink
          label="See member's documents"
          icon={openInTab}
          classes={classes}
          onClick={openMemberDocuments}
        />
      </div>
      {showProofOfEligibilityDocumentsBlock && (
        <ProofOfElegibilityDocumentsBlock
          closePolicyPreviewModal={closePolicyPreviewModal}
          isProcessingView
          goToPIPCoverageSection={goToPIPCoverageSection}
          openMemberDocuments={openMemberDocuments}
        />
      )}
      {showAllHouseholdResidentsIncludedBlock && <AllHouseholdResidentsIncludedBlock isProcessingView />}
      {showNewPIPFormRequiredBlock && <NewPIPFormRequiredBlock isProcessingView previewId={previewId} />}
      <PreAcceptChangesVerification />
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        spacing={0}
        className={classes.internalNoteFieldContainer}
      >
        <FormField
          id="internalNote"
          name="internalNote"
          type="string"
          label="Add an internal note"
          mode="light"
          xs={8}
          ignoreGlobalDisabledState
          permissions={{ isLicensedAction: false }}
        />
        <Button
          id="submit"
          name="submit"
          type="submit"
          variant="contained"
          label="Add an internal note"
          mode="light"
          xs={3}
          color="primary"
          className={classes.submit}
        >
          Process endorsement
        </Button>
      </Grid>
    </Card>
  );
};

ChangesForApprovalSectionProcessingView.propTypes = {
  closePolicyPreviewModal: PropTypes.func.isRequired,
  showProofOfEligibilityDocumentsBlock: PropTypes.bool.isRequired,
  showAllHouseholdResidentsIncludedBlock: PropTypes.bool.isRequired,
  showNewPIPFormRequiredBlock: PropTypes.bool.isRequired,
  goToPIPCoverageSection: PropTypes.func.isRequired,
  openMemberDocuments: PropTypes.func.isRequired,
  previewId: PropTypes.string.isRequired
};

export default observer(ChangesForApprovalSectionProcessingView);
